import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '../../img/icon.png';
import _imports_1 from '../../img/search.png';
import _imports_2 from '../../img/QRCod-Icon.png';
import _imports_3 from '../../img/Primary-tag.png';
import _imports_4 from '../../img/QRCode.png';
import _imports_5 from '../../img/plus.png';
import _imports_6 from '../../img/reduce.png';
const _hoisted_1 = {
  class: "head"
};
const _hoisted_2 = {
  class: "rightbox"
};
const _hoisted_3 = {
  key: 0,
  class: "pop-upNotification"
};
const _hoisted_4 = {
  class: "searchBox"
};
const _hoisted_5 = {
  class: "searchInput"
};
const _hoisted_6 = {
  key: 1,
  class: "pop-upNotification"
};
const _hoisted_7 = {
  key: 2,
  class: "pop-upNotification"
};
const _hoisted_8 = {
  class: "searchBoxTwo"
};
const _hoisted_9 = {
  class: "tabberBox"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  key: 0,
  class: "tabberChildren"
};
const _hoisted_14 = ["onClick"];
import { reactive, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Search } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';
import { getMessageConfig, articleSearchConfig } from "../../api/home";
export default {
  __name: 'headTabbarM',
  setup(__props) {
    const data = reactive({
      title: "",
      index: 0,
      id: "",
      treeSelectList: [],
      input: "",
      pageNum: 1,
      pageSize: 100,
      show: true,
      plusId: "",
      oneShow: false,
      twoShow: false,
      threeShow: false
    });
    const route = useRoute();
    const router = useRouter();
    watch(() => router.currentRoute.value, toPath => {
      if (localStorage.getItem("headId")) {
        data.index = localStorage.getItem("headId");
      }
      if (localStorage.getItem("headValueId")) {
        data.id = localStorage.getItem("headValueId");
      }
    }, {
      immediate: true,
      deep: true
    });
    const treeSelect = () => {
      getMessageConfig().then(res => {
        data.treeSelectList = res.data;
      });
    };
    const clickItems = (id, userId) => {
      router.push({
        path: "/mediumM",
        query: {
          ids: id,
          userId: userId
        }
      });
      data.oneShow = false;
      data.twoShow = false;
      data.threeShow = false;
    };
    const btn = id => {
      console.log(id, "33333");
      if (id == 1) {
        data.oneShow = !data.oneShow;
        data.twoShow = false;
        data.threeShow = false;
      } else if (id == 2) {
        data.twoShow = !data.twoShow;
        data.oneShow = false;
        data.threeShow = false;
      } else if (id == 3) {
        data.threeShow = !data.threeShow;
        data.oneShow = false;
        data.twoShow = false;
      }
    };
    const clickItem = (index, id) => {
      localStorage.setItem("headId", index);
      localStorage.setItem("headValueId", id);
      if (id == '1987831222629982210') {
        router.push({
          path: "/"
        });
      } else if (id == '1988426439470223361') {
        router.push({
          path: "/aboutM"
        });
      } else {
        router.push({
          path: "/mediumM",
          query: {
            userId: id
          }
        });
      }
      data.oneShow = false;
      data.twoShow = false;
      data.threeShow = false;
    };
    const SearchBtn = () => {
      console.log(data.input, "7");
      if (data.input) {
        articleSearchConfig(data.input, data.pageNum, data.pageSize).then(res => {
          console.log(res, "8888");
          if (res.data.length != 0) {
            data.oneShow = false;
            data.twoShow = false;
            data.threeShow = false;
            router.push({
              path: "/redBookM",
              query: {
                name: data.input
              }
            });
          } else {
            ElMessage.warning('请重新输入关键词');
            data.input = "";
          }
        });
      } else {
        ElMessage.warning('请输入关键词');
      }
    };
    const plusBtn = id => {
      data.show = false;
      data.plusId = id;
    };
    const plusBtns = id => {
      data.show = true;
      data.plusId = "";
    };
    onMounted(() => {
      // 代码逻辑0
      treeSelect();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "titile"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        onClick: _cache[0] || (_cache[0] = $event => btn(1)),
        src: _imports_1,
        alt: ""
      }), _createElementVNode("img", {
        onClick: _cache[1] || (_cache[1] = $event => btn(2)),
        src: _imports_2,
        alt: ""
      }), _createElementVNode("img", {
        onClick: _cache[2] || (_cache[2] = $event => btn(3)),
        src: _imports_3,
        alt: ""
      })]), data.oneShow == true ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[4] || (_cache[4] = _createElementVNode("img", {
        src: _imports_1,
        alt: ""
      }, null, -1)), _withDirectives(_createElementVNode("input", {
        placeholder: "请输入搜索关键词",
        type: "text",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => data.input = $event)
      }, null, 512), [[_vModelText, data.input]])]), _createElementVNode("div", {
        class: "Search",
        onClick: SearchBtn
      }, "搜索")])])) : _createCommentVNode("", true), data.twoShow == true ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[5] || (_cache[5] = [_createElementVNode("div", {
        class: "searchBoxOne"
      }, [_createElementVNode("img", {
        src: _imports_4,
        alt: ""
      }), _createElementVNode("div", {
        class: "name"
      }, "协会官方微信")], -1)]))])) : _createCommentVNode("", true), data.threeShow == true ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.treeSelectList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "tabber",
          key: index
        }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
          class: _normalizeClass(["name", data.show == false && data.plusId == item.id ? 'namess' : 'name']),
          onClick: $event => clickItem(index, item.id)
        }, _toDisplayString(item.name), 11, _hoisted_10), item.children && (data.show == true || data.plusId != item.id) ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _imports_5,
          alt: "",
          onClick: $event => plusBtn(item.id)
        }, null, 8, _hoisted_11)) : _createCommentVNode("", true), item.children && data.plusId == item.id && data.show == false ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _imports_6,
          alt: "",
          onClick: $event => plusBtns(item.id)
        }, null, 8, _hoisted_12)) : _createCommentVNode("", true)]), item.children && data.plusId == item.id && data.show == false ? (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (items, indexs) => {
          return _openBlock(), _createElementBlock("div", {
            class: "name",
            key: indexs,
            onClick: $event => clickItems(items.id, item.id)
          }, _toDisplayString(items.name), 9, _hoisted_14);
        }), 128))])) : _createCommentVNode("", true)]);
      }), 128))])])) : _createCommentVNode("", true)]);
    };
  }
};